import $http from "../axios";

const state = {
  invoicesPacks: [],
  invoicesPackQty: 0
};

const getters = {
  invoicesPacks(state) {
    return state.invoicesPacks;
  },

  invoicesPackQty(state) {
    return state.invoicesPackQty;
  }
};

const actions = {
  getInvoicesPack({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          // eslint-disable-next-line prettier/prettier
          `invoices-pack/get-invoices-pack`,
          { params: { ...data } }
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_INVOICES_PACKS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_INVOICES_PACKS(state, payload) {
    state.invoicesPackQty = payload.invoicesPackQty;
    state.invoicesPacks = payload.invoicesPacks;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
